<template>
    <div class="p-col-12 p-md-9 p-mx-auto box">
        <div class="p-text-right">
            <Button 
                label="Add News Team Keyword"
                @click="newItemForm.visible = !newItemForm.visible"
                class="p-button-outlined p-button-info p-button-text" />
        </div>

        <div v-if="newItemForm.visible" class="p-fluid p-formgrid p-grid p-mt-4">
            <div class="p-field p-col-12 p-md-6">
                <span class="p-float-label">
                    <InputText id="keyword" type="text" v-model="newItemForm.keyword"
                    @keyup.enter="insertKeyword()" />
                    <label for="keyword">Keyword</label>
                </span>
            </div>
            <div class="p-col-12 p-md-6">
                <Dropdown class="p-text-left" placeholder="Select Team"
                    v-model="newItemForm.ss_team_id"
                    :options="teams.items" :loading="teams.loading"
                    optionLabel="name" optionValue="ss_team_id"
                    style="width:100%" />
            </div>
            <div class="p-col-12 p-grid p-mt-3">
                <div class="p-col-12 p-md-3">
                    <span class="p-float-label">
                        <InputNumber id="weight_title" v-model="newItemForm.weight_title"
                        @keyup.enter="insertKeyword()" />
                        <label for="weight_title">Title weight</label>
                    </span>
                </div>
                <div class="p-col-12 p-md-3">
                    <span class="p-float-label">
                        <InputNumber id="weight_subtitle" v-model="newItemForm.weight_subtitle"
                        @keyup.enter="insertKeyword()" />
                        <label for="weight_subtitle">Subtitle weight</label>
                    </span>
                </div>
                <div class="p-col-12 p-md-3">
                    <span class="p-float-label">
                        <InputNumber id="weight_content" v-model="newItemForm.weight_content"
                        @keyup.enter="insertKeyword()" />
                        <label for="weight_content">Content weight</label>
                    </span>
                </div>
                <div class="p-col-12 p-md-3">
                    <span class="p-float-label">
                        <InputNumber id="weight_picture_description" v-model="newItemForm.weight_picture_description"
                        @keyup.enter="insertKeyword()" />
                        <label for="weight_picture_description">Picture desc. weight</label>
                    </span>
                </div>
            </div>
            <div class="p-field p-col-12 p-mt-5">
                <span class="p-float-label">
                    <Textarea id="description" type="text" rows="2" :autoResize="true" v-model="newItemForm.description" />
                    <label for="description">Description</label>
                </span>
            </div>
            <div class="p-col-12 p-md-12">
                <div class="p-field">
                    <Button 
                        label="Insert Keyword"
                        @click="insertKeyword()"
                        :loading="newItemForm.loading"
                        class="p-button-outlined p-button-info p-button-text" />
                </div>
            </div>
        </div>
    </div>

    <!-- keyword list -->
    <div class="p-grid p-mx-auto p-mt-4">
        <div class="p-col-12 p-md-10 p-mx-auto p-text-left">
            <Dropdown class="p-col-12 p-md-6" placeholder="Select Team"
                v-model="keywords.ssTeamId"
                @change="getKeywordList()"
                :options="teams.items" :loading="teams.loading"
                optionLabel="name" optionValue="ss_team_id" />
        </div>
        <div class="p-col-12 p-md-10 p-mx-auto p-mt-2">
            <ProgressBar mode="indeterminate" v-show="keywords.loading" style="height: .2em" />

            <Paginator 
                :rows="keywords.itemPerPage"
                :totalRecords="keywords.totalCount"
                :first="keywords.firstItemIndex"
                v-show="keywords.items !== null && keywords.items.length > 0 && keywords.totalCount > keywords.itemPerPage"
                @page="onPage($event)" />

            <DataTable v-show="!keywords.loading && keywords.items !== null && keywords.items.length > 0"
                :rowsPerPageOptions="keywords.itemsPerPageOptions"
                :rowHover="true"
                :value="keywords.items" dataKey="id" responsiveLayout="scroll"
                class="p-mt-2" >
                <Column field="id" header="#" sortable style="width:5%"></Column>
                <Column field="team_name" header="Team name" style="width:15%"></Column>
                <Column field="keyword" header="Keyword" style="width:20%"></Column>
                <Column field="weight_title" header="Title weight" style="width:10%"></Column>
                <Column field="weight_subtitle" header="Subtitle weight" style="width:8%"></Column>
                <Column field="weight_content" header="Content weight" style="width:8%"></Column>
                <Column field="weight_picture_description" header="Picture desc. weight" style="width:8%"></Column>
                <Column field="description" header="Description" style="width:8%"></Column>
                <Column field="log_date" header="Log date" style="width:8%"></Column>
                <Column header="" style="width:10%">
                    <template #body="{data, index}">
                        <Button label="" icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-plain"
                            @click="editKeyword(data, index)" />
                        <Button label="" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-plain"
                            @click="deleteKeyword(data.id, data.keyword)" />
                    </template>
                </Column>
            </DataTable>
            
            <span v-show="keywords.items === null || keywords.items.length === 0">
                No keyword defined for selected team.
            </span>

            <Paginator 
                :rows="keywords.itemPerPage"
                :totalRecords="keywords.totalCount"
                :first="keywords.firstItemIndex"
                v-show="keywords.items !== null && keywords.items.length > 0 && keywords.totalCount > keywords.itemPerPage"
                @page="onPage($event)"
                class="p-mt-4" />

        </div>
    </div>

    <!-- keyword update modal -->
    <Dialog v-model:visible="updateItemForm.visible"
        header="Update keyword"
        :modal="true" class="p-fluid p-col-6">
        <div class="p-grid p-pt-3">
            <div class="p-field p-col-12 p-md-6">
                <span class="p-float-label">
                    <InputText id="keyword" type="text" v-model="updateItemForm.keyword" />
                    <label for="keyword">Keyword</label>
                </span>
            </div>
            <div class="p-col-12 p-md-6">
                <Dropdown class="p-text-left" placeholder="Select Team"
                    v-model="updateItemForm.ss_team_id"
                    :options="teams.items" :loading="teams.loading"
                    optionLabel="name" optionValue="ss_team_id"
                    style="width:100%" />
            </div>
            <div class="p-col-12 p-grid p-mt-1">
                <div class="p-col-12 p-md-6">
                    <span class="p-float-label">
                        <InputNumber id="weight_title" v-model="updateItemForm.weight_title" />
                        <label for="weight_title">Title weight</label>
                    </span>
                </div>
                <div class="p-col-12 p-md-6">
                    <span class="p-float-label">
                        <InputNumber id="weight_subtitle" v-model="updateItemForm.weight_subtitle" />
                        <label for="weight_subtitle">Subtitle weight</label>
                    </span>
                </div>
            </div>
            <div class="p-col-12 p-grid p-mt-1">
                <div class="p-col-12 p-md-6">
                    <span class="p-float-label">
                        <InputNumber id="weight_content" v-model="updateItemForm.weight_content" />
                        <label for="weight_content">Content weight</label>
                    </span>
                </div>
                <div class="p-col-12 p-md-6">
                    <span class="p-float-label">
                        <InputNumber id="weight_picture_description" v-model="updateItemForm.weight_picture_description" />
                        <label for="weight_picture_description">Picture desc. weight</label>
                    </span>
                </div>
            </div>
            <div class="p-field p-col-12 p-mt-3">
                <span class="p-float-label">
                    <Textarea id="description" type="text" rows="2" :autoResize="true" v-model="updateItemForm.description" />
                    <label for="description">Description</label>
                </span>
            </div>
        </div>
        <template #footer>
            <Button label="Update Keyword"
                @click="updateKeyword()"
                :loading="updateItemForm.loading"
                class="p-button p-button-success" />
        </template>
    </Dialog>

</template>



<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import Textarea from 'primevue/textarea'
import Dropdown from 'primevue/dropdown'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Paginator from 'primevue/paginator'
import Dialog from 'primevue/dialog'

import Const from '../utils/const'
import { isEmpty } from '../utils/utils'

import dayjs from 'dayjs'

export default {
    name: 'News Team Keywords',
    components: {
        Button, Dropdown, InputText, InputNumber, Textarea, DataTable, Column, Paginator, Dialog
    },
    data() {
        return {
            newItemForm: {
                visible: false,
                loading: false,
                weight_title: 5,
                weight_subtitle: 3,
                weight_content: 1,
                weight_picture_description: 1
            },
            updateItemForm: {
                visible: false,
                loading: false,
                keywordId: undefined
            },
            teams: {
                loading: false,
                items: []
            },
            keywords: {
                ssTeamId: 0,
                loading: false,
                items: [],
                currentPage: 1,
                totalCount: undefined,
                itemPerPage: undefined,
                itemsPerPageOptions: [5, 10, 20, 30, 50],
                firstItemIndex: undefined
            }
        }
    },
    emits: ["loginResult", "pageLoaded"],
    beforeMount() {
        var page = {
            title: 'News Team Keywords'
        }
        this.$emit('pageLoaded', page)
    },
    mounted() {
        this.getTeamList()
    },
    methods: {
        async getTeamList() {
            let self = this,
                cookies = self.$cookies,
                teams = self.teams,
                toast = self.$toast,
                token = cookies.get('token');
            
            try {
                teams.loading = true

                let response = await self.$http.get(`api/tournaments/${Const.TournamentIds.SuperLig}/teams`, {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);

                    response.data.items.splice(0, 0, {
                        id: 0,
                        name: 'Süper Lig Genel',
                        ss_team_id: 0
                    })

                    teams.items = response.data.items

                    this.getKeywordList()
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Getting team list failed', detail: response.data.mesaj, life: 3000});
                }
            } catch (error) {
                console.log(error)
                toast.add({severity: 'error', summary: 'Error', detail: error});
            } finally {
                teams.loading = false
            }
        },
        async insertKeyword() {
            let self = this,
                newItemForm = self.newItemForm,
                toastMessage = null,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token')
            
            if(isEmpty(newItemForm.keyword)) {
                toastMessage = 'Keyword is empty!'
            } else if(newItemForm.ss_team_id === undefined || newItemForm.ss_team_id === null) {
                toastMessage = 'Team not selected!'
            } else if(newItemForm.weight_title === undefined || newItemForm.weight_title === null) {
                toastMessage = 'Title weight is empty!'
            } else if(newItemForm.weight_subtitle === undefined || newItemForm.weight_subtitle === null) {
                toastMessage = 'Subtitle weight is empty!'
            } else if(newItemForm.weight_content === undefined || newItemForm.weight_content === null) {
                toastMessage = 'Content weight is empty!'
            } else if(newItemForm.weight_picture_description === undefined || newItemForm.weight_picture_description === null) {
                toastMessage = 'Picture description weight is empty!'
            }
            
            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            try {
                newItemForm.loading = true

                let response = await self.$http.post('api/news-team-keywords', newItemForm, {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);

                    newItemForm.keyword = null

                    toast.add({severity:'success', summary: 'Keyword added.', detail:response.data.mesaj, life: 1000});

                    this.getKeywordList()
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Inserting new silenced words failed', detail:response.data.mesaj, life: 3000});
                }
            } catch(error) {
                console.log(error)
                toast.add({severity:'error', summary: 'Error', detail: error});
            } finally {
                newItemForm.loading = false
            }
        },
        async getKeywordList(page = 1, limit = null) {
            let self = this,
                cookies = self.$cookies,
                keywords = self.keywords,
                toast = self.$toast,
                token = cookies.get('token')
            
            try {
                keywords.loading = true

                let response = await self.$http.get(`api/news-team-keywords`, {
                    params: {
                        ss_team_id: this.keywords.ssTeamId,
                        page: page,
                        limit: limit
                    },
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    keywords.items = response.data.items

                    if(keywords.items !== null && keywords.items.length > 0) {
                        keywords.items.forEach(keyword => {
                            if(keyword.ss_team_id === 0) {
                                keyword.team_name = 'Süper Lig Genel'
                            }

                            keyword.log_date = dayjs(keyword.log_date).format('DD/MM/YYYY HH:mm:ss')
                        })
                    }

                    keywords.itemPerPage = response.data.itemPerPage
                    keywords.totalCount = response.data.totalCount
                    keywords.currentPage = page
                    keywords.firstItemIndex = (keywords.currentPage - 1) * keywords.itemPerPage
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity: 'warn', summary: 'Getting team news words failed', detail: response.data.mesaj, life: 3000});
                }
            } catch (error) {
                console.log(error)
                toast.add({severity: 'error', summary: 'Error', detail: error});
            } finally {
                keywords.loading = false
            }
        },
        onPage(event) {
            this.getKeywordList(event.page + 1, event.rows)
        },
        deleteKeyword(keywordId, keyword) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token')
            
            this.$confirm.require({
                message: `Are you sure you want to delete this keyword? (${keyword})`,
                header: 'Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: async () => {
                    try {
                        let response = await self.$http.delete(`api/news-team-keywords/${keywordId}`, {
                            headers: {
                                'authorization': 'Bearer ' + token
                            }
                        })

                        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                            cookies.set("token", response.headers['refresh-token']);

                            self.getKeywordList()

                            toast.add({severity:'success', summary: 'Success', detail: 'Keyword deleted successfully.', life: 1500});
                        } else {
                            console.log(response)
                            toast.add({severity:'warn', summary: 'Delete keyword failed.', detail:response.data.mesaj, life: 3000});
                        }
                    } catch (error) {
                        console.log(error)
                        toast.add({severity: 'error', summary: 'Error', detail: error});
                    }
                },
                reject: () => {}
            });
        },
        editKeyword(keywordItem, index) {
            let self = this,
                updateItemForm = self.updateItemForm
            
            updateItemForm.id = keywordItem.id
            updateItemForm.index = index
            updateItemForm.keyword = keywordItem.keyword
            updateItemForm.ss_team_id = keywordItem.ss_team_id
            updateItemForm.weight_title = keywordItem.weight_title
            updateItemForm.weight_subtitle = keywordItem.weight_subtitle
            updateItemForm.weight_content = keywordItem.weight_content
            updateItemForm.weight_picture_description = keywordItem.weight_picture_description
            updateItemForm.description = keywordItem.description
            updateItemForm.visible = true
            updateItemForm.loading = false
        },
        async updateKeyword() {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                updateItemForm = self.updateItemForm,
                toastMessage = null,
                token = self.$cookies.get('token')
            
            if(isEmpty(updateItemForm.keyword)) {
                toastMessage = 'Keyword is empty!'
            } else if(updateItemForm.ss_team_id === undefined || updateItemForm.ss_team_id === null) {
                toastMessage = 'Team not selected!'
            } else if(updateItemForm.weight_title === undefined || updateItemForm.weight_title === null) {
                toastMessage = 'Title weight is empty!'
            } else if(updateItemForm.weight_subtitle === undefined || updateItemForm.weight_subtitle === null) {
                toastMessage = 'Subtitle weight is empty!'
            } else if(updateItemForm.weight_content === undefined || updateItemForm.weight_content === null) {
                toastMessage = 'Content weight is empty!'
            } else if(updateItemForm.weight_picture_description === undefined || updateItemForm.weight_picture_description === null) {
                toastMessage = 'Picture description weight is empty!'
            }
            
            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            try {
                updateItemForm.loading = true

                let response = await self.$http.put(`api/news-team-keywords/${updateItemForm.id}`, updateItemForm, {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);

                    this.updateItemForm = {
                        visible: false, loading: false
                    }
                    this.keywords.items[updateItemForm.index] = response.data.item

                    toast.add({severity:'success', summary: 'Keyword updated.', detail:response.data.mesaj, life: 1000});
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Inserting new silenced words failed', detail:response.data.mesaj, life: 3000});
                }
            } catch(error) {
                console.log(error)
                toast.add({severity:'error', summary: 'Error', detail: error});
            } finally {
                updateItemForm.loading = false
            }

        }
    }
}
</script>